// Generated by CoffeeScript 1.12.7
(function () {
  Viewthespace.AjaxFormModal = (function () {
    function AjaxFormModal($container) {
      var self;
      self = this;
      $container || ($container = $(document));
      $container.find(".lightbox-ajax").click(function (e) {
        return self.initFancybox($(this));
      });
    }

    AjaxFormModal.prototype.initAjaxBindings = function () {
      var $ajaxForm, self;
      self = this;
      $ajaxForm = $(".fancybox-type-ajax").find("form");
      $ajaxForm.submit(function () {
        $(this).find(".error").removeClass("error");
        $(this).find(".error-message").remove();
        $(this).find(".error-inline").remove();
        return $(this).spin();
      });
      $ajaxForm.bind("ajax:success", function (evt, data, status, xhr) {
        parent.$.fancybox.close();
        return new Viewthespace.Flash(data.notice).show();
      });
      $ajaxForm.bind("ajax:error", function (evt, data, status, xhr) {
        var form, shareRow;
        form = $(this);
        if (data.responseJSON.email_text) {
          self.displayEmailErrors(form, ".share_email_text", data.responseJSON.email_text);
        }
        if (data.responseJSON.email_cc) {
          self.displayEmailErrors(form, ".share_email_cc", data.responseJSON.email_cc);
        }
        if (data.responseJSON.email_bcc) {
          self.displayEmailErrors(form, ".share_email_bcc", data.responseJSON.email_bcc);
        }
        if (data.responseJSON.shareables) {
          return (shareRow = form
            .find(".row-spaces .title")
            .append("<span class='error-inline'>" + data.responseJSON.shareables + "</span>"));
        }
      });
      $ajaxForm.bind("ajax:complete", function (evt, data, status, xhr) {
        return $(this).spin(false);
      });
      $ajaxForm.bind("fileuploadstart", function () {
        return self.loading($(".share-modal"));
      });
      return $ajaxForm.bind("fileuploadstop", function () {
        return self.loaded($(".share-modal"));
      });
    };

    AjaxFormModal.prototype.initDropdowns = function () {
      $(".share-modal .email-cc-button").on("click", function () {
        return $(".share-modal").addClass("cc-enabled");
      });
      return $(".share-modal .email-bcc-button").on("click", function () {
        return $(".share-modal").addClass("bcc-enabled");
      });
    };

    AjaxFormModal.prototype.initCheckbox = function () {
      $(".share-checkbox").on("click", function () {
        var $this;
        $this = $(this);
        $this.toggleClass("checked");
        if ($this.hasClass("enable-read-receipts-checkbox")) {
          $("#share_enable_read_receipts").prop("checked", $this.hasClass("checked"));
        }
        if ($this.hasClass("copy-to-self-checkbox")) {
          $("#share_copy_to_self").prop("checked", $this.hasClass("checked"));
        }
        if ($this.hasClass("log-activity-checkbox")) {
          $("#share_log_activity").prop("checked", $this.hasClass("checked"));
        }
        if ($this.hasClass("spaces-checkbox")) {
          return $(this).children("input").prop("checked", $this.hasClass("checked"));
        }
      });
      $(".enable-read-receipts-checkbox").click();
      return $(".share-checkbox.spaces-checkbox").click();
    };

    AjaxFormModal.prototype.initAttachinary = function ($button) {
      var template;
      template =
        '<ul>\n  <% for(var i=0; i<files.length; i++){ %>\n    <li class="attachinary-file">\n       <span class="filename">\n          <span>\n            <%= files[i].filename %>\n           </span>\n       </span>\n      <a href="#" data-remove="<%= files[i].public_id %>">Remove</a>\n    </li>\n  <% } %>\n</ul>';
      $button.attachinary({
        template: template,
      });
      return $(".share-modal .attachinary_container").detach().appendTo(".textarea-row");
    };

    AjaxFormModal.prototype.loading = function (container) {
      container.addClass("loading");
      container.spin(true);
      return container.find("button").attr("disabled", true);
    };

    AjaxFormModal.prototype.loaded = function (container) {
      container.removeClass("loading");
      container.spin(false);
      return container.find("button").attr("disabled", false);
    };

    AjaxFormModal.prototype.initFancybox = function ($button) {
      var checkedSpaces, self;
      self = this;
      if ($button.hasClass("multishare")) {
        checkedSpaces = $("#search-results")
          .find(".multishare-checkbox.checked")
          .parents(".portfolio_space")
          .map(function () {
            return this.className.match(/space_(\d+)/)[1];
          });
        if (!checkedSpaces.length) {
          new Viewthespace.Flash("Please select some spaces to share.", "alert").show();
          return false;
        } else {
          $button.attr(
            "href",
            $button.attr("href").replace(/\?.*/, "") +
              "?space_ids=" +
              checkedSpaces.toArray().join(",")
          );
        }
      }
      $.fancybox({
        href: $button.attr("href"),
        keys: false,
        live: false,
        type: "ajax",
        closeBtn: false,
        autoSize: false,
        autoHeight: true,
        width: parseInt($button.data("lightbox-width"), 10),
        wrapCSS: $button.data("wrapper-class"),
        padding: 0,
        beforeShow: function () {
          var $email_autocomplete;
          $(".fancybox-skin").removeClass();
          self.initAjaxBindings();
          $email_autocomplete = $("form input.email_autocomplete");
          $(".close").click(function () {
            return parent.$.fancybox.close();
          });
          return self.initDropdowns();
        },
        afterShow: function () {
          var ref;
          self.initAttachinary($(".share-modal .attachinary-input"));
          self.initCheckbox();
          return (ref = $("[id$=_message_html]").data("wysihtml5")) != null
            ? ref.editor.setValue($(".user-signature").html())
            : void 0;
        },
      });
      return false;
    };

    AjaxFormModal.prototype.displayEmailErrors = function (form, field, error) {
      var control;
      control = form.find(field + " .controls");
      $(control).before('<p class="error-message">' + error + "</p>");
      return control
        .addClass("error")
        .find("input")
        .one("change", function (e) {
          control.removeClass("error");
          return control.parent().find(".error-message").remove();
        });
    };

    return AjaxFormModal;
  })();
}.call(this));
